import React from "react"
import { concatStrings, replaceTypo3Links } from "../utilities"

const DfbRte = (props) => {
  return (
    <div
      className={concatStrings("dfb-Rte", props.add_class)}
      dangerouslySetInnerHTML={{
        __html: replaceTypo3Links(props.text),
      }}
    ></div>
  )
}

export default DfbRte
